
import WebFont from 'webfontloader'

const options = {"google":{"families":["Roboto:wght@700"]}}

WebFont.load(options)
